import { SnackbarActionType } from "../constants"
import { ISnackbarAction, ISnackbarState } from "../types";

export const initialSnackbarState: ISnackbarState = {
    open: false,
    message: "initial",
    severity: "success",
}

export const SnackbarReducer = (initialSnackbarState: ISnackbarState, action: ISnackbarAction): ISnackbarState => {
    switch(action.type) {
        case SnackbarActionType.SET_SNACK:
            return {
                ...initialSnackbarState,
                open: true,
                message: action.payload.message,
                severity: action.payload.severity
            }
        case SnackbarActionType.UNSET_SNACK:
            return {
                ...initialSnackbarState,
                open: false,
                message: "",
                severity: 'success'
            };
        default:
            throw Error("No such snack state");
    }
}